import { render, staticRenderFns } from "./ValidarCuenta.vue?vue&type=template&id=0fc4cbff&scoped=true&lang=pug"
import script from "./ValidarCuenta.vue?vue&type=script&lang=js"
export * from "./ValidarCuenta.vue?vue&type=script&lang=js"
import style0 from "./ValidarCuenta.vue?vue&type=style&index=0&id=0fc4cbff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4cbff",
  null
  
)

export default component.exports